export default "__VITE_ASSET__CwGrZDwi__"